export default "__VITE_ASSET__DcMuYPCQ__"